'use strict';
import React, { PureComponent } from 'react';
import SeccionSuperior from './SeccionSuperior';
import SeccionDetalle from './SeccionDetalle';
import SeccionRenglones from './SeccionRenglones';
import { GenericModal } from 'com-gyf-webcore-userinterfacecomponents';

class ModalNuevoAsiento extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            mensajeError: '',
            muestraMensajeConfirmacion: false
        };

        this.cerrarYReiniciarModal = this.cerrarYReiniciarModal.bind(this);
        this.aceptarNuevoAsiento = this.aceptarNuevoAsiento.bind(this);
    }

    componentDidMount() {
        window.onbeforeunload = function (event) {
          if (sessionStorage.getItem('PantallaCambios') == "true") {
            return "¿Quieres salir de este sitio web? Es posible que los cambios no se guarden.";
          }
        };
    }

    componentWillUnmount(){
        window.onbeforeunload = null;
    }

    cerrarYReiniciarModal() {
        const { mostrarOcultarModalAsientosContables, reiniciarCamposModalNuevoAsiento } = this.props;
        mostrarOcultarModalAsientosContables("modalNuevoAsiento", false);
        reiniciarCamposModalNuevoAsiento();
    }

    aceptarNuevoAsiento() {
        const { registrosManuales } = this.props;
        const { renglonesValidos, mensajeError } = this.validarRenglones(registrosManuales);

        if (renglonesValidos) {
            this.props.guardarActualizarAsientoContable("propsModalNuevoAsiento");
            this.cerrarYReiniciarModal();
        } else {
            this.setState({ mensajeError });
        }
    }

      validarRenglones(registrosManuales) {
        const todosLosRegistros = [...registrosManuales];
        let renglonesValidos = true;
        let mensajeError = "";

        if (todosLosRegistros.some(reg => !reg.DescripcionRenglon || !reg.CuentaContableCodigo || !reg.ImporteAsiento)) {
            renglonesValidos = false;
            mensajeError = "Por favor complete todos los campos para poder guardar el asiento.";
        }

        if(this.props.comboModeloNuevoAsiento == 0){
            renglonesValidos = false;
            mensajeError = "Por favor seleccione un modelo para continuar con la carga del asiento.";
        }

        return { renglonesValidos, mensajeError };
    }

    cancelarCambios(event){
        const { mostrarOcultarModalAsientosContables, reiniciarCamposModalNuevoAsiento } = this.props;
        if (sessionStorage.getItem('PantallaCambios') == "true") {
            this.setState({muestraMensajeConfirmacion : true})
            event.preventDefault();
            $("#cancel-modal").modal({ backdrop: "static" });
            $(".modal-backdrop").remove();
        } else {
            $("#cancel-modal").modal("hide");
            mostrarOcultarModalAsientosContables("modalNuevoAsiento", false)
            reiniciarCamposModalNuevoAsiento();
        } 
    }

    onModalConfirmClick() {
        const { mostrarOcultarModalAsientosContables, reiniciarCamposModalNuevoAsiento } = this.props;
        if (sessionStorage.getItem('PantallaCambios') == "true") {
            sessionStorage.removeItem('PantallaCambios')
        }
        $("#cancel-modal").modal("hide");
       mostrarOcultarModalAsientosContables("modalNuevoAsiento", false);
       reiniciarCamposModalNuevoAsiento();

    }

    onEstadoModificado = (nombreCombo, valorCombo) => {
        this.setState({ mensajeError: "" });
        this.props.cambiarOpcionCombo(nombreCombo, valorCombo);
    };

    render() {
        const {  agregarRenglonManual, buscarCuentasContables, modificarRenglonManual, cargarRenglonesManualesFiltradosDelModelo, mostrarOcultarModalAsientosContables, reiniciarCamposModalNuevoAsiento, centrosCosto, comentarios, cuentasContables, inputCuentaContable, inputActivo, actualizarComentarios, cambiarValorInput, cambiarInputActivo, fechaActual, detalleRenglonDatosDesplegados, detallesModeloElegido, desplegarDatosDetalleRenglonNuevoAsiento, selectorFechaNuevoAsiento, modelosManuales, registrosManuales, renglonesManualesFiltrados, usuarioLogin, cambiarOpcionCombo, validarSelectorFecha, obtenerDetallesModelo, comboModeloNuevoAsiento, monedasAsiento} = this.props;

        return (
            <div className="modalContainer AsientosContables__modalContainerNuevoAsiento">
             {!this.state.muestraMensajeConfirmacion && (
               <div className="ABMModelosModalContainer">
                    <div className="ABMModelosModalContainer__header">
                        <div className="ABMModelosModalContainer__contenedorTituloBoton">
                            <div className="ABMModelosModalContainer__titulo">Nuevo asiento contable</div>
                            <div className="ABMModelosModalContainer__botonCerrar" onClick={(event) => this.cancelarCambios(event)}></div>
                        </div>
                        <div className="AsientosContables__modalDetalleAsiento__lineaDivisoria"></div>
                    </div>

                    <div className="AsientosContablesModalContainer__body">
                        <SeccionSuperior
                            modelosManuales={modelosManuales}
                            selectorFechaNuevoAsiento={selectorFechaNuevoAsiento}
                            onEstadoModificado={this.onEstadoModificado}
                            comboModeloNuevoAsiento={comboModeloNuevoAsiento}
                            validarSelectorFecha={validarSelectorFecha}
                            obtenerDetallesModelo={obtenerDetallesModelo}
                            
                        />

                        <div className="AsientosContables__modalDetalleAsiento__lineaDivisoria AsientosContables__modalDetalleAsiento__bodyLineaDivisoria"></div>

                        <SeccionDetalle
                            fechaActual={fechaActual} 
                            detallesModeloElegido={detallesModeloElegido}
                            usuarioLogin={usuarioLogin}
                        />

                        <div className="AsientosContables__modalDetalleAsiento__lineaDivisoria AsientosContables__modalDetalleAsiento__bodyLineaDivisoria"></div>

                        <textarea
                            className="seccionDatosGenerales__inputSelect textAreaComentariosNuevoAsiento"
                            style={{ height: "80px", width: "980px", marginTop: "20px", marginBottom: "18px" }}
                            placeholder="Comentarios..."
                            value={comentarios}
                            maxLength={1999}
                            onChange={(e) => actualizarComentarios(e.target.value)}
                        />

                        <div className="AsientosContables__modalDetalleAsiento__lineaDivisoria AsientosContables__modalDetalleAsiento__bodyLineaDivisoria"></div>

                        <SeccionRenglones
                            centrosCosto={centrosCosto}
                            cuentasContables={cuentasContables}
                            inputCuentaContable={inputCuentaContable}
                            inputActivo={inputActivo}
                            agregarRenglonManual={agregarRenglonManual}
                            buscarCuentasContables={buscarCuentasContables}
                            modificarRenglonManual={modificarRenglonManual}
                            cargarRenglonesManualesFiltradosDelModelo={cargarRenglonesManualesFiltradosDelModelo}
                            cambiarValorInput={cambiarValorInput}
                            cambiarInputActivo={cambiarInputActivo}
                            detalleRenglonDatosDesplegados={detalleRenglonDatosDesplegados}
                            detallesModeloElegido={detallesModeloElegido}
                            renglonesManualesFiltrados={renglonesManualesFiltrados}
                            registrosManuales={registrosManuales}
                            desplegarDatosDetalleRenglonNuevoAsiento={desplegarDatosDetalleRenglonNuevoAsiento}
                            comboModeloNuevoAsiento={comboModeloNuevoAsiento}
                            monedasAsiento={monedasAsiento}
                        />
                        
                    </div>
                    {this.state.mensajeError && <p className="genericLabel warningMessage AsientosContables__marginWarningMessage">{this.state.mensajeError}</p>}
                    <div className="ABMModelosModalContainer__footer">
                        <div>
                            <button className="ABMModelosModalContainer__botonAceptar" onClick={this.aceptarNuevoAsiento}>
                                Aceptar
                            </button>
                        </div>

                        <div>
                            <button className="ABMModelosModalContainer__botonCancelar" onClick={(event) => this.cancelarCambios(event)}>
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
                )}

            {this.state.muestraMensajeConfirmacion && (
                <GenericModal id="cancel-modal"
                    className="modal fade-out modal-center modal-center-asientos-contables"
                    type="ALL_CUSTOM"
                    screenSize="modal-dialog modal-generic"
                    header={<h2 className="modal-title">Descartar Cambios</h2>}
                    footer={<div className="row">
                        <div className="col-xs-5">
                            <button type="button" className="btn btn-cta" onClick={() => this.onModalConfirmClick()}>Descartar Cambios</button>
                        </div>
                        <div className="col-xs-7">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal"    
                             onClick={() => { this.setState({ muestraMensajeConfirmacion: false });
                                                $("#cancel-modal").modal("hide") }} >Cancelar</button>
                        </div>
                    </div>}
                    body={<p>Se han realizado modificaciones, en caso de no guardarlos se perderán ¿Desea descartar los cambios?</p>}
                />
            )}
            </div>
        );
    }
}

export default ModalNuevoAsiento;